import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

interface AssignedResourcesPageStateModel {
  pageIndex: number;
}

const INITIAL_STATE: AssignedResourcesPageStateModel = {
  pageIndex: 0,
};

/**
 * Per-manager view state for the resource manager's right ("assigned") list:
 * just the current page index. The assigned children are already fully in
 * memory in the shared `AssignedResourcesState` tree, so paginating them is a
 * synchronous window — there is nothing async to do and no list to hold here.
 * The facade derives the page window by composing the tree's `childrenOf` with
 * `pageIndex$`; this store only owns the cursor (the facade holds no state).
 *
 * Provided per manager mount, so a parent manager and a nested (dialog) manager
 * over the same shared tree keep independent page cursors.
 */
@Injectable()
export class AssignedResourcesPageState extends ComponentStore<AssignedResourcesPageStateModel> {
  constructor() {
    super({ ...INITIAL_STATE });
  }

  public readonly pageIndex$ = this.select((s) => s.pageIndex);

  public readonly setPage = this.updater((state, pageIndex: number) => ({ ...state, pageIndex }));
}
